<template>
    <div>
        <template v-if="currentUser.isAdmin">
            <SkeletonLoader v-if="isLoading" :skeleton-data="skeletonData"/>
            <UsersList :user-role="'manager'" v-else/>
        </template>
        <UsersAdd/>
<!--      Putting modal in a single place-->
        <DocumentHistoryModal/>
        <SkeletonLoader v-if="isLoading" :skeleton-data="skeletonData"/>
        <UsersList :user-role="'user'" v-else/>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import UsersList from '@/components/users/UsersList';
    import UsersAdd from '@/components/users/UsersAdd';
    import * as userStoreTypes from '../../vuex/modules/user/user.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';
    import {SkeletonLoaderRepository} from '../global/skeleton-loader/SkeletonLoaderRepository';
    import SkeletonLoader from '@/components/global/skeleton-loader/SkeletonLoader';
    import DocumentHistoryModal from "./modals/DocumentHistoryModal.vue";

    export default {
        name: 'users',
        components: {DocumentHistoryModal, UsersAdd, UsersList, SkeletonLoader},
        data: () => ({searchTerm: '', skeletonData: SkeletonLoaderRepository.usersListLayout}),
        computed: {
            ...mapGetters('user', {
                /** @type {Company|*} */
                isLoading: userStoreTypes.GET_IS_LOADING,
            }),
            ...mapGetters('auth', {
                /** @type {CurrentUser|*} */
                currentUser: authStoreTypes.GET_CURRENT_USER,
            }),
        },
        methods: {
            ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyUsers: companyStoreTypes.SET_CURRENT_COMPANY_USERS,
            }),
            ...mapActions('user', {
                /** @type {function|*} */
                getUsers: userStoreTypes.ACTION_GET_USERS,
            }),
            /**
             * Search company by name with 500ms delay.
             */
            attemptSearch() {
                clearTimeout(this.searchTimeout);
                if (this.searchTerm.length < 3 && this.searchTerm.length > 0) return
                this.searchTimeout = setTimeout(async () => {
                    const users = await this.getUsers({companyId: this.$route.params.companyId || this.currentUser.company._id, name: this.searchTerm});
                    this.setCurrentCompanyUsers(users);
                }, 500);
            },
        }
    }
</script>
